module.exports = __webpack_public_path__ + "img/icon2.ed3908e7.png";